import type { SalesMetricType } from '@api';
import type { EChartsCoreOption } from 'echarts/core';

type GetXAxisOptionsArgsType = {
  salesTimeline: SalesMetricType[];
};

type GetXAxisOptionsReturnType = EChartsCoreOption['xAxis'];

export const getXAxisOptions = ({
  salesTimeline,
}: GetXAxisOptionsArgsType): GetXAxisOptionsReturnType => {
  return {
    type: 'category',
    show: false,
    boundaryGap: true,
    data: salesTimeline.map(({ date }) => date),
  };
};
